/**
 * Popup - H5 版本
 * 基于 zarm-v3 Popup 实现
 */
import classNames from 'classnames';
import React from 'react';
import { Popup as ZarmPopup } from 'zarm-v3';

import './index.scss';

const IconCloseUrl = 'https://static.za-doctor.com/za-asclepius-applet/common/w_icon_close.png';

export interface PopupProps {
  visible: boolean;
  onClose: () => void;
  /** 点击蒙层是否关闭弹窗，默认 false */
  maskClosable?: boolean;
  /** 是否显示关闭按钮，默认 false */
  showClose?: boolean;
  /** 弹窗圆角大小，默认 16px */
  borderRadius?: string;
  className?: string;
  children?: React.ReactNode;
}

export const Popup: React.FC<PopupProps> = ({
  visible,
  onClose,
  maskClosable = false,
  showClose = false,
  borderRadius = '16px',
  className,
  children,
}) => (
  <ZarmPopup
    visible={visible}
    direction='bottom'
    onMaskClick={maskClosable ? onClose : undefined}
    className={classNames('hy-popup', className)}
  >
    <div className='hy-popup__content' style={{ borderRadius: `${borderRadius} ${borderRadius} 0 0` }}>
      {showClose && (
        <img
          className='hy-popup__close'
          src={IconCloseUrl}
          alt='close'
          onClick={onClose}
        />
      )}
      {children}
    </div>
  </ZarmPopup>
);

export default Popup;
